import React from "react";
import Hero from "../components/Hero";
import HeaderNav from "../components/HeaderNav";
import Footer from "../components/Footer";
import { Link } from "react-router";
import { HiOutlineArrowTurnRightDown } from "react-icons/hi2";
import { MdContentCopy } from "react-icons/md";
import { ToastSuccess } from "../global/component";
import { ToastContainer } from "react-toastify";
import { Analytics } from "@vercel/analytics/react";
import AuthContext from "../global/auth-context";

const DownloadApp = () => {
  let { adminDetails } = React.useContext(AuthContext);
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Analytics />
        <HeaderNav page={"downloadApp"} />
        <Hero>
          <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
            <p className=" text-white font-bold text-5xl ">Download The</p>
            <div className="gap-3 flex">
              <span className=" text-yellow-400 font-bold text-5xl">
                Green Luck Mobile App
              </span>
            </div>
            <span className=" text-white font-bold text-5xl">Here</span>
            <p className=" text-white font-normal text-xl w-2/3">
              Users can get to download Green Luck Mobile App from Apple App
              Store or Google Play Store.
            </p>
          </div>
          <div className="flex flex-col px-5 py-5 gap-7 h-full phone justify-center z-50">
            <div className="flex gap-3 flex-wrap">
              <span className=" text-white font-bold text-3xl sm:w-full">
                Download The
              </span>

              <span className=" text-yellow-400 font-bold text-3xl">
                Green Luck Mobile App
              </span>
              <span className=" text-white font-bold text-3xl">Here</span>
            </div>
            <p className=" text-white font-normal text-xl w-2/3">
              Users can get to download Green Luck Mobile App from Apple App
              Store or Google Play Store.
            </p>
          </div>
        </Hero>
        <div
          className="  
       bg-myLightGreen
       flex-wrap flex  
       h-auto w-screen 
       flex-col 
       justify-center  
       content-center 
       px-5
       overflow-x-hidden pb-10"
        >
          <div
            className="
             flex 
              flex-wrap-reverse 
              justify-center 
              content-center 
              items-center"
          >
            <div
              className=" flex w-auto "
              data-aos="fade-right"
              data-aos-duration="900"
              data-aos-delay="300"
            >
              <img
                src="greenluckapp.png"
                className=" inline-flex lg:h-96 h-80"
              />
            </div>
            <div
              className="flex gap-4 flex-col"
              data-aos="fade-left"
              data-aos-duration="900"
              data-aos-delay="300"
            >
              <h6 className="font-bold w-96 text-center mt-10 text-myNormalGreen text-2xl sm:text-3xl">
                Green Luck Mobile App
              </h6>
              <p
                style={{
                  color: "black",
                }}
                className="w-96 px-10 text-wrap md:px-2 text-center flex md:text-xl"
              >
                Green Luck - Your winning advantage and ultimate guide to
                profitable betting. Available now on Google Play Store
                and Apple App Store
              </p>
            </div>
          </div>
          <div
            className="gap-4 flex flex-col pt-2"
            // data-aos="fade-up"
            // data-aos-duration="900"
            // data-aos-delay="300"
          >
            <h6 className="font-bold w-96 text-center text-myNormalGreen text-2xl sm:text-3xl self-center">
              Download Below
            </h6>
            <div className="gap-3 flex content-center justify-center items-center px-10">
              <a
                // href="https://play.google.com/store/apps/details?id=com.greenluck"
                href={adminDetails?.playstore}
                download={"Green Luck"}
                target="_blank"
              >
                <img src="playstore.jpg" className="h-10 rounded-lg lg:h-12" />
              </a>
              <h6 className="text-center font-semibold text-black">OR </h6>
              <a
                href="https://apps.apple.com/us/app/green-luck/id6745555874"
                target="_blank"
              >
                <img src="appstore.jpg" className="h-10 rounded-lg lg:h-12" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DownloadApp;
